export const formatPrice = (price) => {
  if (price == null) return '';
  if (price < 1 && price !== 0) return `${price.toFixed(2).slice(2)}¢`;
  return `$${parseFloat(price).toFixed(2)}`;
};

const iOSPlatforms = [
  'iPad Simulator',
  'iPhone Simulator',
  'iPod Simulator',
  'iPad',
  'iPhone',
  'iPod'
];

export const isIOS = () => (
  iOSPlatforms.includes(navigator?.platform)
  // iPad on iOS 13 detection
  || (navigator?.userAgent?.includes('Mac') && 'ontouchend' in document)
);
